<template>
  <div class="component-form-wizard-side-bar-menu">
    <ul :class="['component-form-wizard-side-bar-menu__list']">
      <li
        v-for="item in items"
        :key="item.step"
        :class="[
          'component-form-wizard-side-bar-menu__item',
          {
            'component-form-wizard-side-bar-menu__item--completed':
              item.completed,
            'component-form-wizard-side-bar-menu__item--focused': item.focused,
            'component-form-wizard-side-bar-menu__item--disabled':
              item.disabled,
            'component-form-wizard-side-bar-menu__item--error': item.error
          }
        ]"
        @click="item.disabled ? null : onItemClick(item.key)"
      >
        <div class="component-form-wizard-side-bar-menu__item__icon">
          <i :class="getIconByState(item)"></i>
        </div>

        <div class="component-form-wizard-side-bar-menu__item__title">
          {{ item.title }}
        </div>

        <div
          v-if="item.optional"
          class="component-form-wizard-side-bar-menu__item__optional"
        >
          (optional)
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'FormWizardSideBarMenu',
  props: {
    items: {
      type: Array,
      required: true
    },
    onItemClick: {
      type: Function,
      required: true
    }
  },
  methods: {
    getIconByState(item) {
      switch (true) {
        case item.disabled:
          return 'icon-blank'
        case item.focused:
          return 'icon-dash'
        case item.error:
          return 'icon-close'
        case item.completed:
          return 'icon-checkmark'
        default:
          return 'icon-blank'
      }
    }
  }
}
</script>

<style lang="scss">
.component-form-wizard-side-bar-menu {
  position: relative;
  width: 220px;
  // width: 260px;
  background-color: $gray-100;

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
    line-height: 2;
  }

  &__item {
    position: relative;
    display: flex;
    color: $gray-600;
    cursor: pointer;
    align-items: baseline;
    user-select: none;
    @include transition();

    &__icon {
      width: rem(20px);
      font-size: rem(10px);
      @include transition();
    }

    &__title {
      font-size: 1rem;
      @include transition();
    }

    &__optional {
      font-size: 0.9rem;
      opacity: 0.66;
      padding-left: rem(4px);
      @include transition();
    }

    &--focused & {
      &__title {
        color: $gray-900;
        font-weight: 500;
      }

      &__icon {
        color: $blue-900;
      }
    }

    &--disabled {
      opacity: 0.5;
      cursor: default;
    }

    &--error {
    }

    &--completed {
    }

    @include media-breakpoint-down(sm) {
      &__title {
        font-size: 1.3rem;
      }

      &__optional {
        font-size: 1.2rem;
      }
    }
  }
}
</style>
